import Ajax from '../common/ajax'

export default {
  model: 'exam',
  getPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/page`, queryParam)
  },
  getEvaluateExamPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/pageEvaluateExam`, queryParam)
  },
  getEvaluateExamNewPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/pageEvaluateStatistics`, queryParam)
  },
  getPageEvaluateCertificate (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/pageEvaluateCertificate`, queryParam)
  },
  UpdatePrintStatus (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/updatePrintStatus`, queryParam)
  },
  getInfo (id) {
    return Ajax.get(`/api/gradeEvaluation/v1/${this.model}/detail/${id}`)
  },
  getUserExamInfo (id) {
    return Ajax.get(`/api/gradeEvaluation/v1/${this.model}/evaluateDetail/${id}`)
  },
  publish (data) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/publishEvaluate`, data)
  },
  exportExcel (param) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/exportEvaluateExam`, param)
  },
  getExportExamLicense (param) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/exportExamLicense`, param)
  },
  getImportExamResult (param) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/importExamResult`, param)
  },
  getexportExamResult (param) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/exportExamResult`, param)
  },
  getexportEvaluateExamResult (param) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/exportEvaluateExamResult`, param)
  },
  getexportCertificateExamResult (param) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/exportEvaluatecCertificate`, param)
  },
  getSummaryList (batchId) {
    return Ajax.get(`/api/gradeEvaluation/v1/${this.model}/countInfo/${batchId}`)
  },
  getChangeRoom (param) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/changeRoom`, param)
  },
  getExamInfo (id) {
    return Ajax.get(`/api/gradeEvaluation/v1/${this.model}/info/${id}`)
  },
  updateEvaluate (param) {
    return Ajax.put(`/api/gradeEvaluation/v1/${this.model}/updateEvaluate`, param)
  },
  resetExamInfo (id) {
    return Ajax.get(`/api/gradeEvaluation/v1/${this.model}/resetEvaluateStatus/${id}`)
  },
  publishEvaluate (param) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/batchPublishEvaluate`, param)
  },
  getPageReceiverInfo (param) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/pageReceiverInfo`, param)
  },
  exportReceiverInfo (param) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/exportReceiverInfo`, param)
  }
}
